// extracted by mini-css-extract-plugin
var _1 = "qLT82";
var _2 = "O8FX4";
var _3 = "dYbXg";
var _4 = "FYFs7";
var _5 = "bhZCC";
export { _1 as "hasCollaborators", _2 as "others", _3 as "owner", _4 as "positioner", _5 as "users" }
